import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleInvoice
export const getSaleInvoice = createAsyncThunk("saleInvoice/getSaleInvoice", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getSaleInvoice({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all saleInvoice
export const getAllSaleInvoice = createAsyncThunk("saleInvoice/getAllSaleInvoice", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllSaleInvoice();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("saleInvoice/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleInvoice/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleInvoice/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleInvoice({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleInvoiceById = createAsyncThunk(
  "saleInvoice/getSaleInvoiceById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getSaleInvoiceDeliveryDetail = createAsyncThunk(
  "saleInvoice/getSaleInvoiceDeliveryDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceDeliveryDetail(id);
      if (data?.data.deliveryNotesDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.deliveryNotesDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, deliveryNotesDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getSaleInvoiceAdditionalChargeList = createAsyncThunk(
  "saleInvoice/getSaleInvoiceAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleInvoice
export const createSaleInvoice = createAsyncThunk(
  "saleInvoice/createSaleInvoice",
  async (createData, { rejectWithValue }) => {
    const {
      deliveryNoteMain,
      saleInvoiceDetails,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      partyAccount,
      saleInvoiceMainPartyDetails,
      saleInvoiceMainVehicleDetail,
      salesInvoiceMainAdditionalChargeCost,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        deliveryNoteMain,
        saleInvoiceDetails,
        voucherDateBs,
        voucherDate,
        narration,
        branch,
        partyAccount,
        saleInvoiceMainPartyDetails,
        saleInvoiceMainVehicleDetail,
        salesInvoiceMainAdditionalChargeCost,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createSaleInvoice(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateSaleInvoice = createAsyncThunk(
  "saleInvoice/updateSaleInvoice",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      partyAccount,
      status,
      documentsAttach,
      saleInvoiceMainPartyDetails,
      saleInvoiceMainVehicleDetail,
      // refVoucher,
      saleInvoiceDetails,
      discountAmount,
      grandTotal,
      vatAmount,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        partyAccount,
        status,
        voucherDateBs,
        voucherDate,
        saleInvoiceMainPartyDetails,
        saleInvoiceMainVehicleDetail,
        // refVoucher,
        saleInvoiceDetails,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updateSaleInvoice(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "saleInvoice/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
